(() => {
  const dialog = document.querySelector('[data-doi-article-viewer]');
  const main = document.querySelector('main');
  if (!dialog || !main || typeof dialog.showModal !== 'function') return;
  const stage = dialog.querySelector('[data-viewer-stage]');
  const photo = dialog.querySelector('[data-viewer-image]');
  const caption = dialog.querySelector('[data-viewer-caption]');
  const count = dialog.querySelector('[data-viewer-count]');
  const close = dialog.querySelector('[data-viewer-close]');
  const previous = dialog.querySelector('[data-viewer-previous]');
  const next = dialog.querySelector('[data-viewer-next]');
  const status = dialog.querySelector('[data-viewer-status]');
  const records = new WeakMap();
  const launchers = new WeakMap();
  const excluded = 'aside, nav, .doi-author, .doi-native__author, .doi-related, .doi-related-stories, [data-doi-around], [data-doi-reviews], [data-doi-nature-stories], [data-photo], [data-gallery], [data-rental-gallery], .leaflet-container, .maplibregl-map, button, .doi-native__newsletter';
  let group = [];
  let index = 0;
  let opener = null;
  let previousOverflow = '';
  let previousOverscroll = '';

  function imageURL(value) {
    try {
      const url = new URL(value, location.href);
      return /^https?:$/.test(url.protocol) ? url : null;
    } catch { return null; }
  }

  function qualify(img) {
    if (records.has(img)) return records.get(img);
    if (img.closest(excluded)) return null;
    if (!img.matches('.doi-native__hero-image') && !img.closest('[data-doi-article-body], .rte, .article__body, .article-template__content')) return null;
    const width = img.naturalWidth || parseInt(img.getAttribute('width'), 10);
    const height = img.naturalHeight || parseInt(img.getAttribute('height'), 10);
    if ((width && width < 160) || (height && height < 100)) return null;
    if (!img.currentSrc && !img.getAttribute('src')) return null;
    const link = img.closest('a');
    const linkedURL = link && imageURL(link.getAttribute('href'));
    if (link && (!linkedURL || !/\.(?:avif|gif|jpe?g|png|webp)$/i.test(linkedURL.pathname))) return null;
    const launcher = link || img;
    const record = { img, launcher, original: linkedURL?.href || '' };
    records.set(img, record);
    launchers.set(launcher, record);
    launcher.setAttribute('role', 'button');
    launcher.setAttribute('tabindex', '0');
    launcher.setAttribute('aria-haspopup', 'dialog');
    launcher.setAttribute('aria-controls', dialog.id);
    launcher.setAttribute('aria-label', dialog.dataset.enlarge.replace('__name__', img.alt || dialog.dataset.photo));
    launcher.setAttribute('data-article-photo', '');
    if (link) {
      link.removeAttribute('href');
      link.removeAttribute('target');
      link.removeAttribute('download');
    }
    return record;
  }

  function scan() { main.querySelectorAll('img').forEach(qualify); }

  function source(record) {
    const img = record.img;
    const url = imageURL(record.original || img.currentSrc || img.src);
    if (!url) return '';
    if (/\/cdn\/shop\//.test(url.pathname) || url.hostname === 'cdn.shopify.com') {
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      url.searchParams.set('width', '3840');
    }
    return url.href;
  }

  function render() {
    const record = group[index];
    const text = record.img.closest('figure')?.querySelector('figcaption')?.textContent.trim() || record.img.alt || '';
    status.textContent = '';
    stage.setAttribute('aria-busy', 'true');
    photo.alt = record.img.alt || dialog.dataset.photo;
    photo.src = source(record);
    caption.textContent = text;
    count.textContent = dialog.dataset.count.replace('__number__', index + 1).replace('__total__', group.length);
    previous.hidden = next.hidden = group.length < 2;
  }

  function open(record) {
    scan();
    group = [...main.querySelectorAll('img')].map(img => records.get(img)).filter(item => item && item.img.isConnected && item.img.getClientRects().length && !item.img.closest('[hidden]'));
    index = group.indexOf(record);
    if (index < 0) return;
    opener = record.launcher;
    render();
    if (!dialog.open) {
      previousOverflow = document.documentElement.style.overflow;
      previousOverscroll = document.documentElement.style.overscrollBehavior;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.overscrollBehavior = 'none';
    }
    close.focus({ preventScroll: true });
  }

  function move(delta) { index = (index + delta + group.length) % group.length; render(); }
  function finish() { if (dialog.open) dialog.close(); }
  main.addEventListener('click', event => {
    const launcher = event.target.closest('[data-article-photo]');
    const record = launcher && launchers.get(launcher);
    if (!record) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(record);
  }, true);
  main.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const record = launchers.get(event.target);
    if (!record) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(record);
  }, true);
  close.addEventListener('click', finish);
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  stage.addEventListener('click', event => { if (event.target === stage) finish(); });
  photo.addEventListener('load', () => { stage.setAttribute('aria-busy', 'false'); status.textContent = ''; });
  photo.addEventListener('error', () => { stage.setAttribute('aria-busy', 'false'); status.textContent = dialog.dataset.error; });
  dialog.addEventListener('cancel', event => { event.preventDefault(); finish(); });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    document.documentElement.style.overscrollBehavior = previousOverscroll;
    photo.removeAttribute('src');
    status.textContent = '';
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      if (group.length > 1) move(event.key === 'ArrowLeft' ? -1 : 1);
    }
    if (event.key !== 'Tab') return;
    const buttons = [...dialog.querySelectorAll('button')].filter(button => !button.hidden && !button.disabled);
    const first = buttons[0], last = buttons[buttons.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  scan();
  main.addEventListener('load', event => { if (event.target.tagName === 'IMG') qualify(event.target); }, true);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(main, { childList: true, subtree: true });
})();
